(function () {
    'use strict';

    var marquee = document.querySelector('.marquee');
    var marqueeTrack = document.querySelector('.marquee__track');
    if (!marquee || !marqueeTrack) return;

    var copies = Math.ceil(window.innerWidth / marqueeTrack.offsetWidth) + 1;
    for (var i = 0; i < copies; i++) {
        marquee.appendChild(marqueeTrack.cloneNode(true));
    }
})();
